import moment from 'moment-timezone';
import { useMemo } from 'react';

import { useCountriesAsArray, useCountry } from 'store/modules/countries/hooks';
import { CountryAbbreviation } from 'types/models/country';

export function useTimezonesAsArray() {
  const countries = useCountriesAsArray();

  return useMemo(
    () =>
      countries.flatMap((country) =>
        moment.tz.zonesForCountry(country.shortcode)
      ),
    [countries]
  );
}

export function useTimezonesForCountry(countryAbbreviation: CountryAbbreviation) {
  const country = useCountry(countryAbbreviation);

  return useMemo(
    () => (country ? moment.tz.zonesForCountry(country.shortcode) : []),
    [country]
  );
}
